export const APP_REFUND_EXPORT_FIRST_YEAR = 2021;
